import { render } from "./ExistingItemsPopup.vue?vue&type=template&id=489c3d4b&scoped=true"
import script from "./ExistingItemsPopup.vue?vue&type=script&lang=js"
export * from "./ExistingItemsPopup.vue?vue&type=script&lang=js"

import "./ExistingItemsPopup.vue?vue&type=style&index=0&id=489c3d4b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489c3d4b"]])

export default __exports__